define.alias("shared/components/shared/post/secondary/activity/wrapper", "settings/components/shared/post/secondary/activity/wrapper");